import type { SchemaDigitalOrder, SchemaDigitalOrderStatus } from '@/shared/api/openApi';

const ORDER_STATUS_MAPPING: Record<SchemaDigitalOrderStatus, string> = {
    NEW: 'Новый',
    CANCELLED: 'Отменен',
    COMPLETED: 'Завершен',
    PENDING_PAYMENT: 'Ожидает оплаты',
    WAIT_FOR_EMAIL_SENDING: 'Завершен',
} as const;

export const getDigitalOrderStatus = (order: SchemaDigitalOrder): string | null =>
    ORDER_STATUS_MAPPING[order.status] ?? null;
